export default __webpack_public_path__ + "static/media/all_w1024.d2feefdc.jpeg";